const secondsToTimecode = (seconds: number): string => {
    let timecode = new Date(seconds * 1000).toISOString().substr(14, 9);
    timecode = timecode.substr(0, 2) === "00" ? timecode.substr(3) : timecode;
    return `${timecode}s`;
};
export default secondsToTimecode;
